/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceEditNoteDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceEditNoteDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceEditNoteDto
     */
    noteId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceEditNoteDto
     */
    text?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceEditNoteDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceEditNoteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceEditNoteDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceEditNoteDto {
    return WebApiServicesDataTransferObjectsGroupServiceEditNoteDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceEditNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceEditNoteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'noteId': !exists(json, 'noteId') ? undefined : json['noteId'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceEditNoteDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceEditNoteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'noteId': value.noteId,
        'text': value.text,
    };
}

